import { InjectionToken } from '@angular/core';
import { libPrefix } from '@app/core/pcs-modal/constants';

export interface StoreModalConfig {
  stateKey?: string;
}

export const ModalConfig = new InjectionToken<StoreModalConfig>(`${libPrefix}/modal-store-config`);
export const InternalConfig = new InjectionToken<StoreModalConfig>(`${libPrefix}/modal-internal-store-config`);
